<template>
  <div>
    <!-- <div class="mainTitle">代理人员</div> -->
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="所属机构" prop="sourceType">
              <el-select style="width:100%" v-model="searchForm.agentId" clearable>
                <el-option v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="姓名/号码" prop="name">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入姓名/号码"
                auto-complete="off"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12" style="float:right">
            <!-- <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>-->

            <el-button-group style="float:right">
              <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
              <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">添加代理人员</el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
          <!-- <el-button type="danger" @click="batchDeleteAgentUserInfo" icon="el-icon-minus">批量删除</el-button> -->
        </el-col>
        <!-- <el-col style="text-align: right" :span="12">
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button style="text-align: right" type="primary" @click="exportExcel" :loading="loading" icon="el-icon-upload2">导出</el-button>
        </el-col>-->
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="agentInfo.name" label="所属机构" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="account" label="手机"></el-table-column>
        <el-table-column prop="amount" label="账户余额(元)"></el-table-column>
        <el-table-column prop="enabled" label="状态" width="100" align="center">
          <template slot-scope="row">
            <el-switch
              v-model="row.row.enabled"
              @change="updateSwitching(row)"
              active-value="1"
              inactive-value="0"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click="selection = scope.row.id, editFormVisible = true"
              ></i>
              <!-- <i
                class="iconfont iconzhongzhi mainColor"
                title="重置密码"
                @click="resetPassword(scope.row.id)"
              ></i>
              <i
                class="iconfont iconjilu mainColor"
                title="开通记录"
                @click="selection = scope.row.id,agentAmountLogPageList(scope.row.id)"
              ></i>-->
              <!-- <span @click="selection = scope.row.id, editFormVisible = true">编辑</span> -->
              <span @click="resetPassword(scope.row.id)">重置密码</span>
              <span @click="selection = scope.row.id,agentAmountLogPageList(scope.row.id)">开通记录</span>
              <!-- <span @click="deleteStudent(scope.row.id)">解除绑定</span> -->
              <!-- <span @click="deleteAgentUserInfo(scope.row)">删除</span> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加代理人员" :visible.sync="addFormVisible" width="800px" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <!-- <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="账号" prop="account">
          <el-input v-model="addForm.account" placeholder="请输入账号" auto-complete="off" maxlength="50"></el-input>
        </el-form-item>
          </el-col>-->
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="所属机构" prop="agentId">
              <el-select style="width:100%" v-model="addForm.agentId" @change="organizationsChange">
                <el-option v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="机构可分配余额(元)：" label-width="200">{{amount}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="人员姓名" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入姓名"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="账户余额" prop="amount">
              <el-input
                type="number"
                v-model="addForm.amount"
                placeholder="请输入金额"
                auto-complete="off"
                maxlength="18"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="角色" prop="roleId">
              <el-select style="width:100%" v-model="addForm.roleId">
                <el-option
                  clearable
                  v-for="i in roletions"
                  :key="i.id"
                  :label="i.name"
                  :value="i.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="是否启用" prop="enabled">
              <!-- <el-input type="number" v-model="addForm.enabled" placeholder="请输入启用 1启用" auto-complete="off" maxlength="10"></el-input> -->
              <el-radio v-model="addForm.enabled" label="1">启用</el-radio>
              <el-radio v-model="addForm.enabled" label="0">禁用</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="手机号码" prop="account">
              <el-input
                v-model="addForm.account"
                placeholder="请输入手机号码"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="登录密码" prop="password">
              <el-input
                v-model="addForm.password"
                placeholder="请输入登录密码"
                auto-complete="off"
                maxlength="50"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="部门" prop="departmentId">
              <el-cascader
                :options="departmentList"
                :props="defaultProps"
                filterable
                placeholder="试试搜索"
                style="width:100%"
                v-model="addForm.departmentId"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12"></el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentUserInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="代理人员详情" :visible.sync="editFormVisible" width="800px" left>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="first">
          <el-form
            ref="editForm"
            :model="editForm"
            :label-width="formLabelWidth"
            :rules="editFormRules"
          >
            <el-row :gutter="20">
              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="所属机构" prop="agentId">
                  <el-select
                    style="width:100%"
                    v-model="editForm.agentId"
                    @change="editOrganizationsChange"
                  >
                    <el-option v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="机构可分配余额(元)：" label-width="200">{{amount}}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="人员姓名" prop="name">
                  <el-input
                    v-model="editForm.name"
                    placeholder="请输入姓名"
                    auto-complete="off"
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="账户余额" prop="amount">
                  <el-input
                    type="number"
                    v-model="editForm.amount"
                    placeholder="请输入金额"
                    auto-complete="off"
                    maxlength="18"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="角色" prop="roleId">
                  <el-select style="width:100%" v-model="editForm.roleId">
                    <el-option
                      clearable
                      v-for="i in roletions"
                      :key="i.id"
                      :label="i.name"
                      :value="i.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="是否启用" prop="enabled">
                  <!-- <el-input type="number" v-model="addForm.enabled" placeholder="请输入启用 1启用" auto-complete="off" maxlength="10"></el-input> -->
                  <el-radio v-model="editForm.enabled" label="1">启用</el-radio>
                  <el-radio v-model="editForm.enabled" label="0">禁用</el-radio>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="手机号码" prop="account">
                  <el-input
                    v-model="editForm.account"
                    placeholder="请输入手机号码"
                    auto-complete="off"
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="登录密码" prop="password">
                  <el-input
                    v-model="editForm.password"
                    placeholder="请输入登录密码"
                    auto-complete="off"
                    maxlength="50"
                    show-password
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :sm="12" :md="12" :lg="12">
                <el-form-item label="部门" prop="departmentId">
                  <el-cascader
                    :options="departmentList"
                    :props="defaultProps"
                    filterable
                    placeholder="试试搜索"
                    style="width:100%"
                    v-model="editForm.departmentId"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :sm="12" :md="12" :lg="12"></el-col>
            </el-row>
          </el-form>
          <div style="text-align:right;margin-top:50px;">
            <el-button @click="editFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="updateAgentUserInfo">确 定</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="开通记录" name="second">
          <el-row>
            <el-col :span="12">
              余额
              <div style="font-size:20px;margin-top:10px;">{{agentAmount.amount}}</div>
            </el-col>
            <el-col :span="12">
              消费金额
              <div style="font-size:20px;margin-top:10px;">{{agentAmount.consumptionAmount}}</div>
            </el-col>
          </el-row>
          <el-table
            ref="multipleTable"
            :data="userInfoPage.rows"
            tooltip-effect="dark"
            style="margin-top: 20px; width: 100%;"
            border
          >
            <el-table-column prop="type" label="类型" width="80"></el-table-column>
            <el-table-column prop="amount" label="金额(元)">
              <template slot-scope="row">
                <span v-if="row.row.amount>=0">{{row.row.amount}}</span>
                <span v-else style="color:red">{{row.row.amount}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注说明" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="createTime" label="时间"></el-table-column>
          </el-table>
          <el-pagination
            background
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            style="margin-top: 20px;text-align: right;"
            :total="userInfoPage.total"
            :page-size="userInfoPage.pageSize"
            :current-page="userInfoPage.pageNumber"
            @size-change="userInfoSizeChange"
            @current-change="userInfoCurrentChange"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "md5";
export default {
  data() {
    return {
      departmentList: [],
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true
      },
      activeName: "first",
      amount: "",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      roletions: [],

      userInfoPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        name: ""
      },
      addForm: {
        account: "",
        name: "",
        amount: "",
        password: "",
        departmentId: "",
        enabled: "1"
      },
      addFormRules: {
        departmentId: [
          {
            required: true,
            message: "请选择部门",
            trigger: "blur"
          }
        ],
        agentId: {
          required: true,
          message: "请选择机构",
          trigger: "change"
        },
        roleId: {
          required: true,
          message: "请选择角色",
          trigger: "change"
        },
        account: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "账号长度在1到50个字"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1到50个字"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "密码长度在1到50个字"
          }
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "blur"
        }
      },
      editForm: {
        account: "",
        name: "",
        amount: "",
        password: "",
        enabled: "",
        departmentId: ""
      },
      editFormRules: {
        departmentId: [
          {
            required: true,
            message: "请选择部门",
            trigger: "blur"
          }
        ],
        agentId: {
          required: true,
          message: "请选择机构",
          trigger: "change"
        },
        roleId: {
          required: true,
          message: "请选择角色",
          trigger: "change"
        },
        account: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "账号长度在1到50个字"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1到50个字"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "密码长度在1到50个字"
          }
        ],
        enabled: {
          required: true,
          message: "请选择是否启用",
          trigger: "blur"
        }
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/agentUserInfo/upload`,
      fileList: [],
      loading: true,
      organizations: [],
      agentAmount: {}
    };
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    userInfoSizeChange(pageSize) {
      this.userInfo.pageSize = pageSize;
      this.agentAmountLogPageList();
    },
    userInfoCurrentChange(pageNumber) {
      this.userInfo.pageNumber = pageNumber;
      this.agentAmountLogPageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getAgentRoleInfoList(agentId) {
      this.api.agentInfo
        .getAgentRoleInfoList({ agentId: agentId })
        .then(result => {
          this.roletions = result.data;
        });
    },
    getAgentUserInfo() {
      this.api.agentUserInfo
        .getAgentUserInfo({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
          this.editForm.enabled = String(this.editForm.enabled);
          this.editOrganizationsChange();
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateSwitching(row) {
      let obj = {
        id: row.row.id,
        enabled: row.row.enabled
      };
      this.api.agentUserInfo.enabledUser(obj).then(result => {
        if (result.success) {
          this.pageList();
        } else {
          this.pageList();
          this.$message.error(result.message);
        }
      });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.agentUserInfo
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          for (let i in this.page.rows) {
            this.page.rows[i].enabled = String(this.page.rows[i].enabled);
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAgentUserInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addForm.password = md5(this.addForm.password);
          var length = this.addForm.departmentId.length - 1;
          this.addForm.departmentId = this.addForm.departmentId[length];
          this.api.agentUserInfo
            .addAgentUserInfo(this.addForm)
            .then(result => {
              if (result.success) {
                this.addFormVisible = false;
                this.pageList();
                this.$message.success(result.message);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateAgentUserInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          var length = this.editForm.departmentId.length - 1;
          this.editForm.departmentId = this.editForm.departmentId[length];
          this.api.agentUserInfo
            .updateAgentUserInfo(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentUserInfo(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentUserInfo
            .deleteAgentUserInfo([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    resetPassword(row) {
      this.$confirm("您确定要重置密码吗？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.agentUserInfo.resetPassword({ id: row }).then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
        });
      });
    },
    agentAmountLogPageList() {
      this.getAgentUserAmountStats();
      let obj = {
        pageNumber: this.userInfoPage.pageNumber,
        pageSize: this.userInfoPage.pageSize,
        userId: this.selection
      };
      this.api.agentUserInfo.agentAmountLogPageList(obj).then(result => {
        this.userInfoPage.rows = result.data.records;
        this.userInfoPage.total = result.data.total;
        this.activeName = "second";
        this.editFormVisible = true;
      });
    },
    getAgentUserAmountStats() {
      this.api.agentUserInfo
        .getAgentUserAmountStats({ id: this.selection })
        .then(result => {
          this.agentAmount = result.data;
        });
    },
    deleteStudent(row) {
      this.$confirm("您确定要解除绑定吗？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.student.deleteStudent([{ id: row }]).then(resule => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    batchDeleteAgentUserInfo() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentUserInfo
            .deleteAgentUserInfo(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.loading = true;
      this.$refs.searchForm.resetFields();
      this.searchForm.agentId = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      if (!response.success) {
        return this.$message.error(response.message);
      }
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.agentUserInfo
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.agentUserInfo
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getAgentInfoList() {
      this.api.agentUserInfo.getAgentInfoList().then(result => {
        this.organizations = result.data;
      });
    },
    organizationsChange() {
      this.api.agentUserInfo
        .getAgentAmount({ agentId: this.addForm.agentId })
        .then(result => {
          this.amount = result.data;
        });
      this.getAgentRoleInfoList(this.addForm.agentId);
    },
    editOrganizationsChange() {
      this.api.agentUserInfo
        .getAgentAmount({ agentId: this.editForm.agentId })
        .then(result => {
          this.amount = result.data;
        });
      this.getAgentRoleInfoList(this.editForm.agentId);
    },
    handleClick(tab, event) {
      console.log(tab.name, event);
      if (tab.name == "second") {
        this.agentAmountLogPageList();
      }
    },
    departmentTreeList() {
      this.api.department.getNewDepartmentTreeList().then(result => {
        if (result.success) {
          this.departmentList = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.amount = "";
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.userInfoPage.rows = [];
        this.amount = "";
        this.activeName = "first";
      } else {
        this.getAgentUserInfo();
      }
    }
  },
  filters: {
    NumFormat: function(value) {
      if (!value) return "0";
      var intPart = Number(value) | 0; // 获取整数部分
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      var floatPart = ""; //预定义小数部分
      var valueSplit = String(value);
      var value2Array = valueSplit.split(".");
      //=2表示数据有小数位
      if (value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分

        if (floatPart.length == 1) {
          //补0,实际上用不着
          return intPartFormat + "." + floatPart;
        } else {
          return intPartFormat + "." + floatPart;
        }
      } else {
        return intPartFormat + floatPart;
      }
    }
  },
  mounted() {
    this.pageList();
    this.getAgentInfoList();
    this.departmentTreeList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/agentUserInfo/index.vue